export const SUCCESS_GET_SURCHARGES = 'SUCCESS_GET_SURCHARGES';
export const FAILED_GET_SURCHARGES = 'FAILED_GET_SURCHARGES';
export const SUCCESS_CREATE_SURCHARGE = 'SUCCESS_CREATE_SURCHARGE';
export const FAILED_CREATE_SURCHARGE = 'FAILED_CREATE_SURCHARGE';
export const SUCCESS_UPDATE_SURCHARGE = 'SUCCESS_UPDATE_SURCHARGE';
export const FAILED_UPDATE_SURCHARGE = 'FAILED_UPDATE_SURCHARGE';
export const SUCCESS_DELETE_SURCHARGE = 'SUCCESS_DELETE_SURCHARGE';
export const FAILED_DELETE_SURCHARGE = 'FAILED_DELETE_SURCHARGE';



// WEBPACK FOOTER //
// src/state/constants/costConstants.js